import { AxiosInstance } from 'axios'
import nProgress from 'nprogress'
import { baseApiURL, apiEndPoints } from '../config'
import { IAddRmatAPITypes, IUpdateRmatAPITypes, IAddIntake, IAddTaskAPITypes } from 'src/context/types'
import { IAddSubProgram, ICourseData } from 'src/context/common'
import { IAddGroupAPI } from 'src/components/Groups/GroupCommon'

import _ from 'lodash'

export interface IDataParamsProgram {
  q: string | undefined
  pageNumber: number | undefined
  pageSize: number | undefined
  category: string
}
export interface DataParams {
  q?: string
  status?: string
  pageSize?: number
  pageNumber?: number
  academicYear?: number | string | null
  code?: string
  name?: string
  program?: string
  studyMode?: string
  search?: string
  year?: string
  semester?: string
}

export interface IGraduationDataParams {
  programCode: string
  academicYear: string
  qualifiedStatus?: string
  cumLaude?: boolean
  symbol?: string
  applicationStatus?: string
  search?: string
  startDate?: string
  endDate?: string
}

interface groupDataParams {
  academicYear: number
  code: string
}
interface courseAcademicReportpayload {
  programCode: string
  courseCode: string
  groupCode: string
}

interface IDataParams {
  q: string | undefined
  pageNumber: number | undefined
  pageSize: number | undefined
}
export default class Academic {
  baseUrl = `${baseApiURL}academics/`
  enrollmentUrl = `${baseApiURL}enrolment/`
  apiServer: AxiosInstance
  constructor(apiServer: AxiosInstance) {
    this.apiServer = apiServer
  }

  async addProgram(payload: any) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.program
    try {
      const response = await this.apiServer.post(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error fetching in adding program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getGroupListByYearCode(params: groupDataParams) {
    nProgress.start()

    const endUrlName = params
      ? `${this.baseUrl + apiEndPoints?.groups}?academicYear=${params?.academicYear}&programCode=${params?.code}`
      : this.baseUrl + apiEndPoints?.groups

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data
    } catch (err: any) {
      console.log('Error fetching group list by academic year and program code========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAllFacilitator() {
    nProgress.start()

    const endUrlName = this.baseUrl + apiEndPoints?.facilitator

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data
    } catch (err: any) {
      console.log('Error fetching group list by academic year and program code========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAllVenu() {
    nProgress.start()

    const endUrlName = this.baseUrl + apiEndPoints?.venu

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data
    } catch (err: any) {
      console.log('Error fetching group list by academic year and program code========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async updateProgram(payload: any, code: string | number) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.program}/${code}`
    try {
      const response = await this.apiServer.patch(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error fetching in adding program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getCoursesById(code: number | string) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.programCourses
    try {
      const response = await this.apiServer.get(`${endUrlName}${code}`)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error fetching student detail ========>', err?.message)
      nProgress.done()
    }
    nProgress.done()
  }

  async addStudent(payload: any) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.student
    try {
      const response = await this.apiServer.post(endUrlName, payload)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching in adding program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getCoursrAcademicReport(payload: courseAcademicReportpayload) {
    nProgress.start()

    try {
      const response = await this.apiServer.get(
        `${this.baseUrl + apiEndPoints?.courseAcademicReport}?programCode=${payload?.programCode}&courseCode=${
          payload?.courseCode
        }&groupCode=${payload.groupCode}`
      )

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching in adding program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async updateStudent(payload: any, id: number) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.student
    try {
      const response = await this.apiServer.patch(`${endUrlName}/${id}`, payload)

      return response
    } catch (err: any) {
      console.log('Error fetching in adding program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async editProgram(payload: any, id: number | string) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.program
    try {
      const response = await this.apiServer.patch(`${endUrlName}/${id}`, { ...payload })

      return response
    } catch (err: any) {
      console.log('Error updating program details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async updateGroupByCode(payload: any, code: number | string) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.groups
    try {
      const response = await this.apiServer.patch(`${endUrlName}/${code}`, { ...payload })

      return response
    } catch (err: any) {
      console.log('Error updating RMat details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getGroupDetailsByCode(code: number | string) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.groups
    try {
      const response = await this.apiServer.get(`${endUrlName}/${code}`)

      return response
    } catch (err: any) {
      console.log('Error fetching Rmat details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getProgramList(params?: IDataParamsProgram) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.program}?pageNumber=${params?.pageNumber ?? 1}&&pageSize=${
      params?.pageSize ?? 30
    }&category=${params?.category}`
    if (params?.q) endUrlName = `${endUrlName}&&search=${params?.q}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching Program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAllProgramList(params?: IDataParams) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.allProgram}`
    if (params?.q) endUrlName = `${endUrlName}?search=${params?.q}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching all Program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAllProgramListOptimized(params?: IDataParams) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.allProgramOptmized}`
    if (params?.q) endUrlName = `${endUrlName}?search=${params?.q}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching all Program list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getProgram(programCode: number | string) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.program
    try {
      const response = await this.apiServer.get(`${endUrlName}/${programCode}`)

      return response
    } catch (err: any) {
      console.log('Error fetching All program ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAllSemesterList(params?: IDataParams) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.allSemester}`
    if (params?.q) endUrlName = `${endUrlName}?search=${params?.q}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching all Semester list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAllDepartment() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.department
    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error in fetching all departments ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getProgramListByCode(code: number | string) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.program
    try {
      const response = await this.apiServer.get(`${endUrlName}/${code}`)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching program list by Id details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getAllProgramListByCategory(category: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.program}/category/${category}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching all Program list By category ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAllProgramName(programCode: number | string) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.programsCode
    try {
      const response = await this.apiServer.get(`${endUrlName}/${programCode}`)

      return response
    } catch (err: any) {
      console.log('Error fetching All program Name details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getRmatProgramList(params?: DataParams) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.Rmat}?pageNumber=${params?.pageNumber}&&pageSize=${
      params?.pageSize
    }`
    if (params?.q) endUrlName = `${endUrlName}&&search=${params?.q}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching RmatProgram list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getDuplicateRmat(code: string, id?: number) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.duplicateRmat}?code=${code}`
    if (id) endUrlName = `${endUrlName}&rmatId=${id}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching Duplicate Rmat ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async checkDuplicateGroup(code: string, id?: number) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.duplicateGroup}?code=${code}`
    if (id) endUrlName = `${endUrlName}&groupId=${id}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error in checking duplicate group ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async checkDuplicateProgram(code: string, id?: number) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.duplicateProgram}?code=${code}`
    if (id) endUrlName = `${endUrlName}&programId=${id}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error in checking duplicate program ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async checkDuplicateProgramName(name: string, id?: number) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.duplicateProgramName}?name=${name}`
    if (id) endUrlName = `${endUrlName}&programId=${id}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error in checking duplicate program ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async checkDuplicateCourse(code: string | number, id?: number) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.duplicateCourse}?code=${code}`
    if (id) endUrlName = `${endUrlName}&courseId=${id}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error in checking duplicate course code ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async addRmat(payload: IAddRmatAPITypes) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.Rmat
    try {
      const response = await this.apiServer.post(endUrlName, payload)
      nProgress.done()

      return response
    } catch (err: any) {
      console.log('Error in saving RMAT Details ========>', err?.message)
    }
  }
  async updateRmat(params: IUpdateRmatAPITypes, code: number | string | undefined) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.Rmat
    try {
      const response = await this.apiServer.patch(`${endUrlName}/${code}`, { ...params })

      return response
    } catch (err: any) {
      console.log('Error updating RMat details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getRmatDetails(code: number | string) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.Rmat
    try {
      const response = await this.apiServer.get(`${endUrlName}${code}`)

      return response
    } catch (err: any) {
      console.log('Error fetching Rmat details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getGroupList(params?: DataParams) {
    nProgress.start()
    const paramWithoutNullValue = !!params ? _.pickBy(params, _.identity) : {}
    const paramsAsQuery = !!paramWithoutNullValue
      ? `?${new URLSearchParams(paramWithoutNullValue as URLSearchParams).toString()}`
      : ''

    const endUrlName = `${this.baseUrl + apiEndPoints.groups}${paramsAsQuery}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response.data
    } catch (err: any) {
      console.log('Error fetching group list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getStudentList(params: DataParams) {
    nProgress.start()

    let endUrlName = `${this.baseUrl + apiEndPoints.student}?pageNumber=${params?.pageNumber}&pageSize=${
      params?.pageSize
    }`

    if (params?.q) endUrlName = `${endUrlName}&&search=${params?.q}`
    try {
      const response = await this.apiServer.get<any>(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error fetching student list ========>', err?.message)
    }
  }

  async exemptCourses(params: any) {
    const endUrlName = this.baseUrl + apiEndPoints.exemptCourse
    try {
      const response = await this.apiServer.put(endUrlName, params)

      return response
    } catch (err: any) {
      console.log('Error fetching edit venue details ========>', err?.message)
    }
  }

  async getIntakeList(params?: DataParams) {
    nProgress.start()

    let endUrlName = params
      ? `${this.baseUrl + apiEndPoints?.intake}?pageNumber=${params?.pageNumber}&pageSize=${params?.pageSize}`
      : this.baseUrl + apiEndPoints?.intake

    if (params?.q) endUrlName = `${endUrlName}&&search=${params?.q}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching intake list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAllIntakeList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints?.allIntake
    try {
      const response = await this.apiServer.get(endUrlName)
      console.log('response ========>', response)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching intake list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async addIntake(payload: IAddIntake) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.intake
    try {
      const response = await this.apiServer.post(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error in saving intake Details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async updateIntake(params: IAddIntake, code: number | string | undefined) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.intake
    try {
      const response = await this.apiServer.patch(`${endUrlName}/${code}`, { ...params })

      return response
    } catch (err: any) {
      console.log('Error fetching group list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async checkDuplicateIntake(params: IAddIntake) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.duplicateIntake
    try {
      const response = await this.apiServer.post(endUrlName, params)

      return response
    } catch (err: any) {
      console.log('Error fetching group list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getStudentIntakeList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.studentintake
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching group list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getCoursesList(params: any) {
    nProgress.start()

    let endUrlName = `${this.baseUrl + apiEndPoints.courses}?pageNumber=${params?.pageNumber}&pageSize=${
      params?.pageSize
    }`

    if (params?.q) {
      endUrlName = `${this.baseUrl + apiEndPoints.courses}?pageNumber=${params?.pageNumber}&pageSize=${
        params?.pageSize
      }&&search=${params?.q}&subProgramCode=${params?.subProgramCode}`
    } else if (params?.subProgramCode) {
      endUrlName = `${this.baseUrl + apiEndPoints.courses}?pageNumber=${params?.pageNumber}&pageSize=${
        params?.pageSize
      }&subProgramCode=${params?.subProgramCode}`
    }

    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error fetching Courses list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getCourseListByCode(code: number | string, params: IDataParams) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.coursesByProgramCode}?pageNumber=${params?.pageNumber}&pageSize=${
      params?.pageSize
    }&&programCode=${code}`

    if (params?.q)
      endUrlName = `${this.baseUrl + apiEndPoints.coursesByProgramCode}?pageNumber=${params?.pageNumber}&pageSize=${
        params?.pageSize
      }&&search=${params?.q}&&programCode=${code}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching course list by Id details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async addCourse(payload: ICourseData) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.courses
    try {
      const response = await this.apiServer.post(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error in saving course Details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async editCourse(params: ICourseData, code: number | string | undefined) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.courses
    try {
      const response = await this.apiServer.patch(`${endUrlName}/${code}`, { ...params })

      return response
    } catch (err: any) {
      console.log('Error in Editing courses Details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async addGroup(payload: IAddGroupAPI) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.groups
    try {
      const response = await this.apiServer.post(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error fetching Group list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getScheduleList(code: string) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.schedule
    try {
      const response = await this.apiServer.get(`${endUrlName}/${code}`)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching schedule list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getIntakeStudentList(code: any) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.intakeStudent
    try {
      const response = await this.apiServer.get(`${endUrlName}/${code}`)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching schedule list ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async addTask(payload: any) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.scheduleTask
    try {
      const response = await this.apiServer.post(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error in saving Add task Details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async addSchedule(payload: any) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.schedule
    try {
      const response = await this.apiServer.post(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error in saving Add task Details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async updateSchedule(payload: any, code: string) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.schedule}/${code}`
    try {
      const response = await this.apiServer.put(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error in saving Add task Details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async updateEditTask(params: IAddTaskAPITypes, scheduleId: number | string | undefined) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.scheduleTask
    try {
      const response = await this.apiServer.patch(`${endUrlName}/${scheduleId}`, { ...params })

      return response
    } catch (err: any) {
      console.log('Error updating task  details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async deleteTask(id: string | number | undefined) {
    const apiUrl = `${this.baseUrl + apiEndPoints.scheduleTask}/${id}`
    try {
      const response = await this.apiServer.delete<any>(apiUrl)

      return response
    } catch (err: any) {
      console.log('Error deleting  schedule-task ========>', err?.message)
    }
  }
  async deleteSchedule(code: string | number | undefined) {
    const apiUrl = `${this.baseUrl + apiEndPoints.schedule}/${code}`
    try {
      const response = await this.apiServer.delete<any>(apiUrl)

      return response
    } catch (err: any) {
      console.log('Error deleting schedule Data ========>', err?.message)
    }
  }
  async getAllStudentDetailsById(studentCode: number | string, programCode: string | number) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.studentAllRecord
    try {
      const response = await this.apiServer.get(`${endUrlName}/${studentCode}/${programCode}`)

      return response
    } catch (err: any) {
      console.log('Error fetching All student Records details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getActiveGroup() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.activeGroup
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching groups details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getSubProgramListByProgramCode(code: number | string, params: IDataParams) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.subProgram}?pageNumber=${params?.pageNumber}&pageSize=${
      params?.pageSize
    }&&programCode=${code}`

    if (params?.q)
      endUrlName = `${this.baseUrl + apiEndPoints.subProgram}?pageNumber=${params?.pageNumber}&pageSize=${
        params?.pageSize
      }&&search=${params?.q}&&programCode=${code}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error fetching sub-program list by programCode details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async addSubProgram(payload: any) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.subProgram
    try {
      const response = await this.apiServer.post(endUrlName, payload)

      return response
    } catch (err: any) {
      console.log('Error in saving sub-program Details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async editSubProgram(params: IAddSubProgram, code: number | string | undefined) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.subProgram
    try {
      const response = await this.apiServer.patch(`${endUrlName}/${code}`, { ...params })

      return response
    } catch (err: any) {
      console.log('Error in Editing sub-program Details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async checkDuplicateSubProgram(code: string, id?: number) {
    nProgress.start()
    let endUrlName = `${this.baseUrl + apiEndPoints.duplicateSubProgram}?code=${code}`
    if (id) endUrlName = `${endUrlName}&subProgramId=${id}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error in checking duplicate sub-program ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getGroupFilterOptionList() {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.GroupFilterList
    try {
      const response = await this.apiServer.get(endUrlName)

      return response.data
    } catch (err: any) {
      console.log('Error getting Corporate Student Filter Option List ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getSemesterByYear(code: string | number, year: number) {
    nProgress.start()

    const endUrlName = `${this.baseUrl + apiEndPoints.allSemester}/program/${code}/studyYear/${year}`

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error in fetching semester ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getGraduationRecords(payload: IGraduationDataParams) {
    nProgress.start()
    try {
      const {
        programCode,
        academicYear,
        qualifiedStatus,
        applicationStatus,
        cumLaude,
        symbol,
        startDate,
        endDate,
        search = ''
      } = payload

      let url = `${this.baseUrl + apiEndPoints?.graduation}?programCode=${programCode}&academicYear=${academicYear}`

      if (qualifiedStatus) {
        url += `&qualifiedStatus=${qualifiedStatus}`
      }
      if (applicationStatus) {
        url += `&applicationStatus=${applicationStatus}`
      }
      if (cumLaude !== undefined) {
        url += `&cumLaude=${cumLaude}`
      }
      if (symbol) {
        url += `&symbol=${symbol}`
      }
      if (startDate) {
        url += `&startDate=${startDate}`
      }
      if (endDate) {
        url += `&endDate=${endDate}`
      }
      if (search?.length > 0) {
        url += `&search=${search}`
      }
      const response = await this.apiServer.get(url)

      return response
    } catch (err: any) {
      console.log('Error fetching academic records ========>', err)

      return err
    } finally {
      nProgress.done()
    }
  }

  async getClassRoomData(venueType: string) {
    nProgress.start()
    try {
      const response = await this.apiServer.get(`${this.baseUrl + apiEndPoints?.classroom}?venueType=${venueType}`)

      return response
    } catch (err: any) {
      console.log('Error fetching academic records ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getAllStudentDetailsByAppCode(
    studentCode: number | string,
    programCode: string | number,
    isAcademicTranscript?: boolean
  ) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.progressReport
    try {
      const response = await this.apiServer.get(
        `${endUrlName}/${studentCode}/${programCode}${isAcademicTranscript ? '?isAcademicTranscript=true' : ''}`
      )

      return response
    } catch (err: any) {
      console.log('Error fetching All student Records details ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }
  async getTranscriptHeaders(appCode: any) {
    nProgress.start()
    try {
      const response = await this.apiServer.get(
        `${this.baseUrl + apiEndPoints?.academicRecord}/table-headers/${appCode}`
      )

      return response
    } catch (err: any) {
      console.log('Error fetching academic records ========>', err?.message)

      return err
    } finally {
      nProgress.done()
    }
  }

  async getIntakeLists(code: string) {
    const endUrlName = `${this.baseUrl + apiEndPoints.intakeLists}/${code}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response.data
    } catch (err: any) {
      console.log('Error fetching edit venue details ========>', err?.message)
    }
  }

  async exportToExcelOne(payload: any) {
    nProgress.start()

    let endUrlName =
      this.baseUrl +
      apiEndPoints.toExcel +
      `?programCode=${payload?.programCode}&academicYear=${payload?.academicYear}&qualifiedStatus=${payload?.qualifiedStatus}`

    if (payload?.search) {
      endUrlName += `&search=${encodeURIComponent(payload.search)}`
    }
    if (payload?.applicationStatus) {
      endUrlName += `&applicationStatus=${payload?.applicationStatus}`
    }
    if (payload?.cumLaude !== undefined) {
      endUrlName += `&cumLaude=${payload?.cumLaude}`
    }
    if (payload?.symbol) {
      endUrlName += `&symbol=${payload?.symbol}`
    }
    if (payload?.startDate) {
      endUrlName += `&startDate=${payload?.startDate}`
    }
    if (payload?.endDate) {
      endUrlName += `&endDate=${payload?.endDate}`
    }

    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error in toExcel ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async exportToExcelTwo(payload: any) {
    nProgress.start()
    const endUrlName =
      this.baseUrl + apiEndPoints.excel + `?programCode=${payload?.programCode}&academicYear=${payload?.academicYear}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.log('Error in Excel ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getStudentIntakesList(studentCode: string) {
    nProgress.start()
    const endUrlName = `${this.enrollmentUrl + apiEndPoints.admittedStudents}?search=${studentCode}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response.data?.data?.data[0]?.intakes || []
    } catch (err: any) {
      console.log('Error Getting Admitted Student List ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async downloadAcademicProgressReport(studentCode: number | string, programCode: string | number) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.downloadProgressReport
    try {
      const response = await this.apiServer.get(`${endUrlName}?studentCode=${studentCode}&programCode=${programCode}`, {
        responseType: 'blob'
      })

      return response
    } catch (err: any) {
      console.log('Error in downloading academic transcript ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async enableProgressReport(appCode: any) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints?.enableProgressReport}/${appCode}`
    try {
      const response = await this.apiServer.patch(endUrlName)

      return response
    } catch (err: any) {
      console.error('Error fetching progress report enable/disable ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getProgressReportLogs(appCode: any) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints?.progressReportLogs}/${appCode}`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response?.data?.data
    } catch (err: any) {
      console.error('Error fetching progress report activity logs ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async downloadAcademicTranscript(studentCode: number | string, programCode: string | number) {
    nProgress.start()
    const endUrlName = this.baseUrl + apiEndPoints.downloadAcademicTranscriptReport
    try {
      const response = await this.apiServer.get(`${endUrlName}/${studentCode}/${programCode}`, {
        responseType: 'blob'
      })

      return response
    } catch (err: any) {
      console.log('Error in downloading academic transcript ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async requestProgressReport(payload: any) {
    nProgress.start()
    const endUrlName = `${this.baseUrl + apiEndPoints.progressReportRequest}`

    try {
      const response = await this.apiServer.post(endUrlName, payload)

      return response.data
    } catch (err: any) {
      console.log('Error sending progress report request mail ========>', err?.message)
    } finally {
      nProgress.done()
    }
  }

  async getAllVenueListNew() {
    const endUrlName = `${this.baseUrl + apiEndPoints.getAllVenueListNew}?venueTypes=EXTERNAL,REGENESYS_BUSINESS_SCHOOL`
    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error while Getting Venue List', err?.message)

      return err
    }
  }

  async getDepartmentListNew() {
    const endUrlName = this.baseUrl + apiEndPoints.departmentListNew
    try {
      const response = await this.apiServer.get(endUrlName)

      return response
    } catch (err: any) {
      console.log('Error while Getting Department List', err?.message)

      return err
    }
  }
}
